import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { MaterialsPage } from './pages/MaterialsPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen bg-sandev-bg font-sans text-sandev-text" data-id="element-1">
        <Navbar data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/about" element={<AboutPage data-id="element-8" />} data-id="element-7" />
            <Route path="/materials" element={<MaterialsPage data-id="element-10" />} data-id="element-9" />
            <Route path="/contact" element={<ContactPage data-id="element-12" />} data-id="element-11" />
          </Routes>
        </main>
        <Footer data-id="element-13" />
      </div>
    </Router>;
}